import { makeAutoObservable, observable } from "mobx";
import OfferModel from "@model/OfferModel";
import VoucherModel from "@model/cart/VoucherModel";

export default class CartModel {
  constructor() {
    makeAutoObservable(this);
  }

  id = "";
  start = "";
  instalment = false;
  end = "";
  people = 0;
  total_price = 0;
  duration = 0;
  extra_total = 0;
  extras_count = 0;
  donation = 0;
  discount = 0;
  deposit_price = 0;
  offer = new OfferModel();
  voucher = new VoucherModel();
  rooms = observable([]);
  extras = observable([]);
  peopleData = observable([]);
  basePrice = 0;
  price_currency = "EUR";
}
